import React from "react";
import { Link, useParams, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ListGroup from "./slides/listGroup";
import CreateGroup from "./slides/createGroup";
import ViewGroup from "./slides/viewGroup";
import EditGroup from "./slides/editGroup";
import "../../../style.scss";

function Brand(props) {
  const params = useParams();
  const location = useLocation();

  const title = "Manage Groups | Chimera Solutions | Insights";
  const routes = [
    {
      name: "list",
      path: "/list",
      component: ListGroup,
    },
    {
      name: "create",
      path: "/create",
      auth: true,
      level: [0, 1],
      component: CreateGroup,
    },
    {
      name: "edit",
      path: "/edit",
      auth: true,
      level: [0, 1],
      component: EditGroup,
    },
    {
      name: "view",
      path: "/view",
      component: ViewGroup,
    },
  ];

  let Error = props.components.setting[0].component;
  let Component = <Error />;
  let showComponent = false;

  if (params.page) {
    const route = routes.find((route) => {
      if (route.name === params.page) {
        if (route.auth) {
          return route.level.includes(props.user.data.level);
        }
        return true;
      }
      return false;
    });

    showComponent = true;

    if (route) {
      const RouteComponent = route.component;
      Component = (
        <RouteComponent
          match={{ params }}
          user={props.user}
          chimeraserv={props.chimeraserv}
          components={props.components}
        />
      );
    }
  }

  const basePath = location.pathname.split("/").slice(0, 3).join("/");

  return (
    <div className="viewContainer">
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <div
        className="heading"
        style={{
          justifyContent: "flex-end",
          marginBottom: "10px",
          padding: "12px",
        }}
      >
        {[0, 1].includes(props.user.data.level) ? (
          <Link to={`${basePath}/main/create`}>
            <FontAwesomeIcon className="icon" icon={["fas", "plus"]} /> Create
            New Group
          </Link>
        ) : (
          <div />
        )}
        <Link to={`${basePath}/main/list`}>List of Groups</Link>
      </div>
      <div className="viewBody">
        {showComponent ? (
          Component
        ) : (
          <ListGroup
            match={{ params }}
            user={props.user}
            chimeraserv={props.chimeraserv}
            components={props.components}
          />
        )}
      </div>
    </div>
  );
}

export default Brand;
